import React, { useCallback, useContext, useEffect, useState } from "react";
import { Context } from "../../../states/Store";
import { tpSearchResultColumns } from "./TPSearchResultTableUtils";
import { useHistory } from "react-router-dom";
import EADataGrid from "../../../components/common/datatable/EADataGrid";
import ROUTES from "../../../config/Routes";
import { addThirdparty } from "../../../services/edge/ThirdpartyService";
import { ERROR } from "../../../services/common/Constants";
import { RoleBasedAccessControlContext } from "services/common/RolesUtils";
import ManagedThirdPartyAttributes
  from '../../../components/thirdparties/managedThirdParty/ManagedThirdPartyAttributes';
import { useTheme } from '@mui/material';
import _ from "lodash";
import { getApiErrorMessageCode } from '../../../services/common/ApiUtils';

function TPSearchResultTable({ loader, results, accountAttributes, hasRestrictedDisclosureTP }) {
  const [state, dispatch] = useContext(Context);
  const { hasAnyOfPrivileges } = useContext(RoleBasedAccessControlContext);
  let history = useHistory();
  const [tpSearchColumns, setTpSearchColumns] = useState([]);
  const [thirdpartyAddLoader, setThirdpartyAddLoader] = useState(false);
  const [thirdpartyIdLoader, setThirdpartyIdLoader] = useState(null);
  const [isOpenAttributesConfiguration, setIsOpenAttributesConfiguration] = useState(false);
  const [attributes, setAttributes] = useState([]);
  const [tpRow, setTPRow] = useState(null);
  const theme = useTheme();

  const addThirdParty = useCallback(
    async (row) => {
      let thirdpartyId;
      const attributesToSave = attributes || [];

      // Ajout du tiers
      if (!row?.onboarded) {
        try {
          setThirdpartyAddLoader(true);
          const thirdpartyToAdd = {
            companyIdType: row.id?.length === 14 ? "CIT001" : "CIT003",
            companyIdValue: row.id,
            companyIdEncrypted: row.isIdEncrypted,
            attributes: attributesToSave,
          };
          const response = await addThirdparty(
            state.account.id,
            thirdpartyToAdd,
            dispatch
          );
          if (response?.content) {
            thirdpartyId = response.content.thirdpartyId;
          }
        } catch (e) {
              dispatch({
                type: "ALERT",
                alert: { type: ERROR, msg: getApiErrorMessageCode(e) }
              });
          setThirdpartyAddLoader(false);
        }
      }

      // Redirect to thirdparty detail
      if (thirdpartyId) {
        const route = ROUTES.THIRDPARTY_DETAIL.replace(
          ":thirdpartyId",
          thirdpartyId
        );
        history.push(`/${state.account.id}/${route}`, {
          prevPath: history.location.pathname,
        });
      }
    },
    [state.account, dispatch, history, attributes]
  );

  // Ouvre la fenêtre de dialogue de définition des attributs s'ils en existent
  const handleResultRowClick = useCallback(async (row) => {
    setThirdpartyIdLoader(row.id)

    if (_.isEmpty(accountAttributes)){
      // Aucun attributs à configurer
      addThirdParty(row);
    }else{
      // Récupération des attributs pour le tiers
      setTPRow(row);
      setIsOpenAttributesConfiguration(true);
    }

  },
    [addThirdParty, accountAttributes]
  );

  useEffect(() => {
    setTpSearchColumns(
      tpSearchResultColumns(handleResultRowClick, thirdpartyAddLoader, thirdpartyIdLoader, hasAnyOfPrivileges, hasRestrictedDisclosureTP, theme)
    );
  }, [handleResultRowClick, thirdpartyAddLoader, thirdpartyIdLoader, hasAnyOfPrivileges, hasRestrictedDisclosureTP, theme]);

  return (
    <>
      <EADataGrid
        loading={loader || thirdpartyAddLoader}
        inputRows={results}
        columns={tpSearchColumns}
        clickable={false}
      />

      {/* Définition des attributs lors de l'ajout d'un tiers géré */}
      {isOpenAttributesConfiguration && (
        <ManagedThirdPartyAttributes
          thirdpartyId={thirdpartyIdLoader}
          onClose={() => {
            setIsOpenAttributesConfiguration(false);
            setThirdpartyIdLoader(false);
          }}
          isOpen={isOpenAttributesConfiguration}
          setAttributes={setAttributes}
          handleValidate={() => addThirdParty(tpRow)}
          accountAttributes={accountAttributes}
          hasRestrictedDisclosure={tpRow.hasRestrictedDisclosure}
          bondType={"managed"}
        />
      )}
    </>
  );
}
export default TPSearchResultTable;
